import { 
    useContext, 
    useEffect, 
    useState 
} from "react";
import { useNavigate } from "react-router-dom";

import { AddVideosAnuncio } from "../../components/AdAnuncio/adAnuncio";
import { Header } from "../../components/header/Header";
import { FormEditUser } from "../../components/managementRegionalComponent/formEditUser";
import { FormNewUser } from "../../components/managementRegionalComponent/formNewUser";
import { ListAllUsers } from "../../components/managementRegionalComponent/listAllUsers";
import { MenuOrderingContainer } from "../../components/menuOrdering/menuOrderingContainer";
import { InnerCameraModal } from "../../components/modalInnerCamera/innerCamera";
import { ContextApi } from "../../context/contextApi";
import { DrawerContext } from "../../context/drawerContext";

import styles from './style.module.scss'

export default function ManagementRegionalPage() {
    let navigate = useNavigate()
    const {
        setShowInnerVideo,
        showInnerVideo,
        setShowMenuOrdering,
        showMenuOrdering,
        setShowUploadVideo,
        setVideoAnuncio
      } = useContext(DrawerContext);
      const { 
        cookies 
    } = useContext(ContextApi);
    const [formNewUser, setFormNewUser] = useState(true);
    const [infoAvancadas, setInfoAvancadas] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            if (!cookies?.surfViewToken?.token || cookies?.surfViewToken?.userRole === false || cookies?.surfViewToken?.userRole === 'regional' ) {
                navigate("/login")
            }
            if ( cookies?.surfViewToken?.userRole === 'regional' ) {
                navigate("/")
            }       
        }, 2000);
    }, [])

     function handleCloseMenuOrdering() {
        setShowMenuOrdering(false);
    }

    function handleCloseInnerVideo() {
        setShowInnerVideo(false);
        setShowUploadVideo(false);
        setVideoAnuncio('');
    }

    return (
        <>
            <Header />
            <div className={styles.containerEditCamera}>
                <div className={styles.boxAbas}>
                    <div 
                    className={formNewUser ? styles.BTNAbaEditCameraActive : styles.BTNAbaEditCameraOff}
                    onClick={() => {
                        setFormNewUser(true);
                        setInfoAvancadas(false);
                    }}
                    >
                        <p>Cadastrar novo usuário</p>
                    </div>
                    <div 
                    className={infoAvancadas ? styles.BTNAbaEditCameraActive : styles.BTNAbaEditCameraOff}
                    onClick={() => {
                        setInfoAvancadas(true);
                        setFormNewUser(false);
                    }}
                    >
                        <p>Editar usuário</p>
                    </div>
                </div>
                {formNewUser &&
                <FormNewUser 
                />}
                {infoAvancadas && 
                <ListAllUsers 
                />}
            </div>
            <AddVideosAnuncio 
            showInnerVideo={showInnerVideo}
            handleCloseInnerVideo={handleCloseInnerVideo}
            />
            <MenuOrderingContainer 
            showMenuOrdering={showMenuOrdering}
            handleCloseMenuOrdering={handleCloseMenuOrdering}
            />
            <InnerCameraModal />
        </>
    )
}